import { render, staticRenderFns } from "./BtnExcluirProjetoAcao.vue?vue&type=template&id=13c7717c&"
import script from "./BtnExcluirProjetoAcao.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirProjetoAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports